
	import {
    getSpectoMaxFileSizeForDisplay,
    getSpectoMaxPdfTifFileSizeForDisplay,
    getTab,
    getTabs,
    isMixPanelenabled
} from '../appConfig/appConfigForward';
	import { Injectable } from 'ng-metadata/core';
	import { JournalsService } from '../journals/journals.service'
 // import {SearchStateService} from '../search/searchState.service';
	import { SearchStateService } from '../search/searchState.service';
	import { SearchFieldsService } from '../search/search.fields.service';
import {getTabToTiles, getBriefResultConfiguration, getFacetConfiguration, getFullViewConfiguration,
    getLocationsConfiguration, getMainMenuConfiguration, getSystemConfiguration,
            getVid,getBackendSystem,getSummonOverAlma,getSearchWithinJournalConfig,getFieldsWithUseTranslation,getUseEsploroAssetPage,
            getUseEsploroSearchPage, getFeatureFlags, getRapidoSAEnabled, getDiscoveryServicesPage,getDiscoveryLocalNoLogin, getDiscoveryWithExternalNoLogin, getLimitedPatronsInAlmaStarter } from '../appConfig/appConfigForward';
	import { getScopes } from '../appConfig/appConfigForward';

const get= require('lodash/get');

@Injectable()
export class ConfigurationUtil {

    private vid = getVid();
    private briefResultConfiguration = getBriefResultConfiguration();
    private locationsTileConfiguration = getLocationsConfiguration();
    private systemConfiguration = getSystemConfiguration();
    private facetConfiguration = getFacetConfiguration();
    private fullViewConfiguration = getFullViewConfiguration();
    private mainMenuConfiguration = getMainMenuConfiguration();
    private summonOverAlma = getSummonOverAlma();
    private rapidoSAEnabled = getRapidoSAEnabled()
    private backendSystem = getBackendSystem();
    private searchWithinJournalConfig = getSearchWithinJournalConfig();
    private scopes = getScopes();
    private fieldsWithUseTranslation = getFieldsWithUseTranslation();
    private useEsploroAssetPage = getUseEsploroAssetPage();
    private useEsploroSearchPage = getUseEsploroSearchPage();
    private featureFlags = getFeatureFlags();
    private discoveryServicesPage = getDiscoveryServicesPage();
    private discoveryLocalNoLogin = getDiscoveryLocalNoLogin();
    private discoveryWithExternalNoLogin = getDiscoveryWithExternalNoLogin();
    private limitedPatronsInAlmaStarter = getLimitedPatronsInAlmaStarter();
    private mixpanelEnabled = isMixPanelenabled();
    private spectoMaxFileSizeForDisplay = getSpectoMaxFileSizeForDisplay();
    private spectoMaxPdfTifFileSizeForDisplay = getSpectoMaxPdfTifFileSizeForDisplay();

    /* private members */
    private configuration: any;

    constructor(private searchStateService: SearchStateService,
        private searchFieldsService: SearchFieldsService,
        private journalsService: JournalsService) {

        this.configuration = {
            facet: {
                mainConfig: this.facetConfiguration,
                tileInterface: 'FacetTileInterface',
                enrich: this.enrichFacetConfiguration
            },
            brief: {
                mainConfig: this.briefResultConfiguration,
                tileInterface: 'ResultTileInterface'
            },
            briefFrbrGeneric: {
                mainConfig: this.briefResultConfiguration,
                tileInterface: 'ResultTileInterfaceFrbrGeneric',
                enrich: this.enrichBriefResultsConfiguration
            },
            locations: {
                mainConfig: this.locationsTileConfiguration,
                tileInterface: 'LocationsTileInterface'
            },
            full: {
                mainConfig: this.fullViewConfiguration,
                tileInterface: 'ResultFullTileInterface'
            },
            mainMenu: {
                mainConfig: this.mainMenuConfiguration,
                tileInterface: 'MainMenuTileInterface'
            }

        };
    }

    getMainMenuConfiguration() {
        return this.mainMenuConfiguration[this.vid + '.' + this.configuration.mainMenu.tileInterface];
    }

    getFacetConfiguration(scope?: string) {
        return this.getConfiguration(this.configuration.facet, scope);
    }

    getBriefResultConfiguration(scope?: string) {
        return this.getConfiguration(this.configuration.brief, scope);
    }

    getBriefResultFrbrGenericConfiguration(scope?: string) {
        return this.getConfiguration(this.configuration.briefFrbrGeneric, scope);
    }

    getLocationsConfiguration(scope?: string) {
        return this.getConfiguration(this.configuration.locations, scope);
    }

    getFullViewConfiguration(scope?: string) {
        return this.getConfiguration(this.configuration.full, scope);
    }

    getSystemConfiguration(key) {
        return this.systemConfiguration[key];
    }

    getViewInstitutionLibraries(){
        return get(window,'appConfig.institution-libraries');
    }


    public getTile(tileId, tiles) {
        if (!tiles) {
            return '';
        }
        let advancedTile = tiles.map((tile) => {
            if (tile.startsWith(this.vid + '.' + tileId + '.')) {
                return tile;}
        }).filter(this.filterEmpty);
        if (advancedTile.length > 0) {
            return advancedTile[0];
        }
        return '';
    }
    private filterEmpty(scope) {
        if (scope !== '') {
            return scope;
        }
    }



    private getConfiguration(configuration, scope) {
        scope = this.getScope(scope);
        let selectedTab;
        if (this.journalsService.isJournalSearch()) {
            selectedTab = this.searchFieldsService.tab || this.journalsService.JOURNAL_SEARCH_TAB;
        } else {
            selectedTab = this.getTabs(scope);
        }
        let tiles = getTabToTiles(selectedTab);
        let selected;
        if (tiles) {
            selected = this.getTile(configuration.tileInterface, tiles);
        }
        if (!selected) {
            selected = this.vid + '.' + configuration.tileInterface + '.' + selectedTab;
        }

        let config = configuration.mainConfig[selected];
             if (!config) {
                selected = this.vid + '.' + configuration.tileInterface + '.' + getTab(scope);
                config = configuration.mainConfig[selected];
                 
                /* PRM-39892
                   Newspapers - After search in NP clicking on NP tab is not showing landing page
                   In this case the scope in for newspaper and the config remains undefined 
                 
                   TODO - remove the following condition after PRM-39997 is fixed
                */
   
                if (!config) {
                    let defaultTab = window.appConfig['primo-view'].scopes[0]['tab-id-for-scope-matching'];
                    selected = this.vid + '.' + configuration.tileInterface + '.' + defaultTab;
                    config = configuration.mainConfig[selected];  
            
                }
             }
        if (configuration.enrich) {
            configuration.enrich(config);
        }


       
        return config;
    }

    private getScope(scope) {
        if (!scope) {
            scope = this.searchStateService.getSearchObject().scope || this.scopes[0];
        }
        if (scope === 'browse_search' && this.isSuprima()){
        	return 'MyInstitution';
        }
        return scope;
    }

	public getScopeName() {
        return this.searchStateService.getSearchObject().scope || this.scopes[0];
    }

    private enrichBriefResultsConfiguration(briefResultsConfig) {
        if (!briefResultsConfig || briefResultsConfig.enriched) {
            return;
        }
        briefResultsConfig.enriched = true;
    }

    private enrichFacetConfiguration(facetConfig) {
        if (!facetConfig || facetConfig.enriched) {
            return;
        }

        /* Add Availability to facet in case of Display 'Show only' facets on top of 'Refine My Results' is checked */
        if (facetConfig.toplevelsidefacet) {
            facetConfig.facetview.splice(0, 0, {
                'count'			: 5,
                'display'		: true,
                'viewinstsort'	: false,
                'id'			: 'facet_tlevel',
                /* PRM-38516 New UI - Open Access Facet should be displayed always at the bottom */
                'sort'			: { '_string': 'open_access', '_int': 5 }, 
                'instsort'		: false,
                'valid'   		: true});

        }

        facetConfig.enriched = true;
    }
    getSummonOverAlma() {
        return this.summonOverAlma;
    }
    getRapidoSAEnabled() {
        return this.rapidoSAEnabled;
    }
    getDiscoveryServicesPage(){
        return this.discoveryServicesPage;
    }

    getDiscoveryLocalNoLogin() {
        return this.discoveryLocalNoLogin;
    }

    getDiscoveryWithExternalNoLogin() {
        return this.discoveryWithExternalNoLogin;
    }
    getLimitedPatronsInAlmaStarter() {
        return this.limitedPatronsInAlmaStarter;
    }

    isMixpanelEnabled() {
        return this.mixpanelEnabled;
    }

    isPartialAlma() {
        return this.isSuprima() &&
            (this.discoveryServicesPage || this.discoveryWithExternalNoLogin || this.discoveryLocalNoLogin);
    }

    getBackendSystem() {
        return this.backendSystem;
    }
    isSuprima() {
        return this.backendSystem === 'suprima';
    }
    getSearchWithinJournalConfig() {
        return this.searchWithinJournalConfig;
    }
    getScopesObj(scope){
        return window.appConfig['primo-view'].scopes.filter(function(obj) { return obj['scope-id'] === scope;});
    }
    getFieldsWithUseTranslation(){
        return this.fieldsWithUseTranslation;
    }

    public getProxyServerPath(){
    	return this.systemConfiguration['Proxy_Server'];
	}
	
	/**
	Return value by full path from json object
	this.jsonPathToValue(this.item, 'pnx.display.title[0]') === 'War'
	this.jsonPathToValue(this.item, 'pnx.display.title') === ['War']
	this.jsonPathToValue(this.item, 'pnx.display.title') === ['War']
	this.jsonPathToValue(this.item, 'pnx.display.identifier.1') === this.jsonPathToValue(this.item, 'pnx.display.identifier[1]')
	*/
	public jsonPathToValue(jsonData, path) {
	    if (!(jsonData instanceof Object) || typeof (path) === "undefined") {
	        throw "Not valid argument:jsonData:" + jsonData + ", path:" + path;
	    }
	    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	    path = path.replace(/^\./, ''); // strip a leading dot
	    let pathArray = path.split('.');
	    for (let i = 0, n = pathArray.length; i < n; ++i) {
	        var key = pathArray[i];
	        if (key in jsonData) {
	            if (jsonData[key] ) {
	                jsonData = jsonData[key];
	            } else {
	                return null;
	            }
	        } else {
	            return key;
	        }
	    }
	    return jsonData;
	}

    private getTabs(scope: any) {
        if (getBackendSystem() === 'suprima' && get(this.searchFieldsService,'searchParams.fn','q').startsWith("BrowseSearch")) {
            if (getTabs().includes('LibraryCatalog')) {
                return 'LibraryCatalog';
            }
        }
        else
            return this.searchFieldsService.tab || getTab(scope);
	}
	
	getUseEsploroAssetPage() {
        return this.useEsploroAssetPage;
    }

    getUseEsploroSearchPage() {
        return this.useEsploroSearchPage;
    }

    getFeatureFlag(flag) {
        return this.isSuprima() && get(this.featureFlags, flag, false);
    }

    getSpectoMaxFileSizeForDisplay() {
        return this.spectoMaxFileSizeForDisplay;
    }

    getSpectoMaxPdfTifFileSizeForDisplay() {
        return this.spectoMaxPdfTifFileSizeForDisplay;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/configurationUtil.service.ts